<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";
</style>

<template>
  <b-form
    class="mx-auto main-margins mx-auto margin-top-content"
    @submit="saveKitPath"
  >
    <b-row class="my-4">
      <b-col sm="3">
        <label for="spreadsheetUrl">Spreadsheet Url</label>
      </b-col>
      <b-col sm="9" class="d-flex gap-1">
        <b-form-input
          id="spreadsheetUrl"
          name="spreadsheetUrl"
          v-model="kitUrl"
          :state="UtilService.isValidUrl(kitUrl)"
        ></b-form-input>
        <b-btn variant="primary" @click="syncKits" :disabled="loading">Sync</b-btn>
      </b-col>
    </b-row>
    <b-row class="my-4 justify-content-between">
      <b-btn variant="primary" @click="$router.go(-1)" :disabled="loading">Return</b-btn>
      <b-btn type="submit" class="border-success text-white" variant="success" :disabled="loading">Save</b-btn>
    </b-row>
  </b-form>
</template>

<script>
import UtilService from "@/services/UtilService";
import ToastService from "@/services/ToastService";
import KitService from "@/services/KitService";
import FrontEndpoints from "@/router/endpoints/FrontEndpoints";

export default {
  name: "Kits",
  title: "Kits - Disneyland CMP",
  data() {
    return {
      kitUrl: "",
      loading: false,
    };
  },
  props: {},
  computed: {
    UtilService() {
      return UtilService
    }
  },
  methods: {
    async syncKits() {
      if (!this.kitUrl) {
        ToastService.error("Error", "Please enter a valid spreadsheet url");
        return
      }

      try {
        this.loading = true;
        ToastService.info("Loading", "Saving data into database...");
        await KitService.syncKits(this.kitUrl);
        ToastService.success("Success", "Kits have been saved into database.");
      } catch (e) {
        this.loading = false;
        ToastService.error("Error saving data into database", e.response.data.errors)
      }

      this.loading = false;
    },
    async saveKitPath(event) {
      event.preventDefault();

      if (!this.kitUrl) {
        ToastService.error("Error", "Please enter a valid spreadsheet url");
        return
      }

      try {
        this.loading = true;
        await KitService.saveKitUrl(this.kitUrl);
        this.loading = false;
        this.$router.push(FrontEndpoints.home);
      } catch (e) {
        ToastService.error("Error", "Error saving url kit into database");
      }
    }
  },
  async mounted(){
    this.loading = true;
    const kitUrl = await KitService.getKitUrl();
    if (kitUrl) {
      this.kitUrl = kitUrl;
    }
    this.loading = false;
  }
};
</script>
